import { type IconName } from '@bettermode/icons/social/types'
import { SsoType } from '@tribeplatform/gql-client/types'

export const SsoIcon = {
  [SsoType.google]: 'google',
  [SsoType.facebook]: 'facebook',
  [SsoType.linkedin]: 'linked-in',
  [SsoType.Discord]: 'discord',
  [SsoType.Slack]: 'slack',
  [SsoType.Apple]: 'apple',
} satisfies Record<string, IconName>
